import { render } from "./setting_next_edit.vue?vue&type=template&id=1a621e98&scoped=true"
import script from "./setting_next_edit.vue?vue&type=script&lang=js"
export * from "./setting_next_edit.vue?vue&type=script&lang=js"

import "./setting_next_edit.vue?vue&type=style&index=0&id=1a621e98&lang=scss&scoped=true"
import "./setting_next_edit.vue?vue&type=style&index=1&id=1a621e98&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a621e98"]])

export default __exports__